export default __webpack_public_path__ + "static/media/information--minimum-speed-30--g1.23729b05.png";